
export const rachelMediaArray = [
  {
    _id: 'rachelMediaId1',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-1-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `Pre-coffee me`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId2',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-2-p.png`,
    description: ``,
    captions: [
      `Caught in the act`,
      `How history will remember me`,
      `How my friends see me`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId3',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `A favorite memory of mine`,
      `Dating me will look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId4',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-4-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `Plandid or candid?`,
      `Don't judge me`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId5',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-5-p.png`,
    description: ``,
    captions: [
      `How my friends see me`,
      `Me in my blogging days`,
      `The advertisement for my life would look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId6',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-6-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Lowkey flex`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId7',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-7-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `My good side`,
      `Get someone who looks at you like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId8',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-8-p.png`,
    description: ``,
    captions: [
      `Me and my best friend`,
      `My life peaked when`,
      `Dating me will look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId9',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-9-p.png`,
    description: ``,
    captions: [
      `The advertisement for my life would look like`,
      `Leave a one-word review for this`,
      `Me in my blogging days`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId10',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-10-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `My quarter life crisis looks like`,
      `#MondaysAmIRight?`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId11',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-11-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `Dating me will look like`,
      `Life outtake`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId12',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-12-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `My quarter life crisis looks like`,
      `#MondaysAmIRight?`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId13',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-13-p.png`,
    description: ``,
    captions: [
      `Dating me will look like`,
      `My weekends look like`,
      `Woke up like this`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId14',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-14-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `Caught in the act`,
      `Post-coffee me`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId15',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-15-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-15-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `Don't judge me`,
      `Caught in the act`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId16',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-16-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-16-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Lowkey flex`,
      `My good side`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId17',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-17-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-17-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `Don't judge me`,
      `Caught in the act`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId18',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-18-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-18-p.png`,
    description: ``,
    captions: [
      `How history will remember me`,
      `Felt cute might delete later`,
      `Dating me will look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId19',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-19-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-19-p.png`,
    description: ``,
    captions: [
      `How my friends see me`,
      `My uniform`,
      `Found in my 90s time capsule`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'rachelMediaId20',
    userId: 'rachelUserId',
    email: 'rachel@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-20-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-rachel-20-p.png`,
    description: ``,
    captions: [
      `I feel famous when`,
      `My uniform`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]